/**
 * /tenants/$slug/authentication/sign-in — Overview: what's live right now.
 */

import { createFileRoute } from "@tanstack/react-router";
import { queryKeys } from "@/lib/query-keys";
import { fetchCascadePolicy } from "@/features/cascade-policy/queries";
import { fetchAllowlist } from "@/features/authenticator-allowlist/queries";
import { signInPolicyQueryOptions } from "@/features/signin-policy/queries";
import { SignInOverview } from "@/features/signin-settings/components/sign-in-overview";

export const Route = createFileRoute("/_authed/tenants/$slug/authentication/sign-in/")({
  // Prefetch, not ensure: each row degrades on its own when its source is
  // unreadable, so one forbidden endpoint never blanks the Overview.
  loader: ({ context }) => {
    const id = context.tenant.id;
    return Promise.all([
      context.queryClient.prefetchQuery({
        queryKey: queryKeys.cascadePolicy.policy(id),
        queryFn: () => fetchCascadePolicy(id),
      }),
      context.queryClient.prefetchQuery(signInPolicyQueryOptions(id)),
      context.queryClient.prefetchQuery({
        queryKey: queryKeys.authenticatorAllowlist.list(id),
        queryFn: () => fetchAllowlist(id),
      }),
    ]);
  },
  component: SignInOverview,
});
